import ConnectionChecker from "@components/ConnectionChecker";

const AppConfiguration = () => {
  return <ConnectionChecker />;
};

export default AppConfiguration;
